import React from "react";
import { EntryTypes } from "../utils/constants";

const EntryTypeSelect = ({ value, onChange, translations }) => {
  return (
    <select
      className="full-width"
      onChange={(e) => onChange(e.target.value)}
      value={value}
      style={{
        direction: translations.setlang === "ar" ? "rtl" : "ltr",
        textAlign: translations.setlang === "ar" ? "right" : "left",
        width: "100%",
      }}
    >
      <option value="" disabled>
        {translations.CreateAccountingEntrypgSelectEntryType}
      </option>
      {Object.keys(EntryTypes).map((t) => (
        <option key={t} value={EntryTypes[t]}>
          {EntryTypes[t]}
        </option>
      ))}
    </select>
  );
};

export default EntryTypeSelect;